import {makeAutoObservable, reaction} from "mobx";
import {DialogStoreInterface} from "../DialogStore";
import {FmsPrinterItem} from "./FmsPrinterStore";
import {FmsCustomerItem} from "./FmsCustomerStore";
import {api} from "../../api";
import {ShipmentProcessTypeDto} from "../../api/fms";
import {isStorageTransferOrInternalProcess} from "./FmsProcessTypeUtil";
import {userPrinterPreferenceStore} from "../ums";
import {vhsPrinterStore} from "../vhs/VhsPrinterStore";

export interface FmsPrinterSelectDialogStoreInterface extends DialogStoreInterface {
    documentPrinter: FmsPrinterItem | undefined
    labelPrinter: FmsPrinterItem | undefined
    customer: FmsCustomerItem | undefined
    processType: ShipmentProcessTypeDto
}

class FmsBatchFinishDialogStore implements FmsPrinterSelectDialogStoreInterface {
    get processType(): ShipmentProcessTypeDto {
        return this._processType;
    }

    set processType(value: ShipmentProcessTypeDto) {
        this._processType = value;
    }

    get labelPrinter(): FmsPrinterItem | undefined {
        return this._labelPrinter;
    }

    set labelPrinter(value: FmsPrinterItem | undefined) {
        this._labelPrinter = value;
    }

    get documentPrinter(): FmsPrinterItem | undefined {
        return this._documentPrinter;
    }

    set documentPrinter(value: FmsPrinterItem | undefined) {
        this._documentPrinter = value;
    }

    get customer(): FmsCustomerItem | undefined {
        return this._customer;
    }

    set customer(value: FmsCustomerItem | undefined) {
        this._customer = value;
    }

    get executing(): boolean {
        return this._executing
    }

    set executing(value: boolean) {
        this._executing = value
    }

    get dialogErrorMessage(): string | undefined {
        return this._dialogErrorMessage
    }

    set dialogErrorMessage(value: string | undefined) {
        this._dialogErrorMessage = value
    }

    get dialogOpen(): boolean {
        return this._dialogOpen
    }

    set dialogOpen(value: boolean) {
        this._dialogOpen = value
    }

    private _dialogOpen: boolean = false
    private _dialogErrorMessage?: string | undefined
    private _executing: boolean = false

    private _documentPrinter: FmsPrinterItem | undefined
    private _labelPrinter: FmsPrinterItem | undefined
    private _customer: FmsCustomerItem | undefined
    private _processType: ShipmentProcessTypeDto = ShipmentProcessTypeDto.REGULAR

    constructor() {
        makeAutoObservable(this)
        reaction(() => [
            userPrinterPreferenceStore.zebraPrinterId,
            userPrinterPreferenceStore.documentPrinterId,
            vhsPrinterStore.options
        ], () => this.resetDefaultPrinter())
    }

    resetDefaultPrinter() {
        const {zebraPrinterId, documentPrinterId} = userPrinterPreferenceStore
        const options = vhsPrinterStore.options
        this.labelPrinter = options.find(p => p.id === zebraPrinterId) || undefined
        this.documentPrinter = options.find(p => p.id === documentPrinterId) || undefined
    }

    async submit(): Promise<boolean | number> {
        const {
            customer,
            processType,
            labelPrinter,
            documentPrinter
        } = this


        const labelPrinterOk = isStorageTransferOrInternalProcess(processType)? true: Boolean(labelPrinter)

        if (!customer || !labelPrinterOk || !documentPrinter) {
            return false
        }

        const customerId = customer.id
        const documentPrinterId = documentPrinter.id
        const labelPrinterId = labelPrinter?.id
        const response = await api.fms.api.finishPackages({
            customerId,
            processType,
            documentPrinterId,
            labelPrinterId
        })
        const responseData = response.data
        if (!responseData) {
            return false
        }
        return responseData.ids.length
    }
}

export {
    FmsBatchFinishDialogStore
}
